// extracted by mini-css-extract-plugin
export default {"r_l":"_82011771cd _476d250498","t":"f25f6f945d"};